import { AdminBlockAttributeInputType, AdminBlockTypeAttribute } from '@headlines/types/block/adminBlockType';

const autoplay: AdminBlockTypeAttribute = {
  label: 'Carousel autoplay',
  key: 'autoplay',
  inputType: AdminBlockAttributeInputType.CHECKBOX,
};

export default autoplay;
